import { firebase } from './../tools/tools';
import { Observable } from 'rxjs/Observable';
import { GenericModel } from './../models/generic.model';
import { ServerModel } from './../models/server.model';

export class DomainsModel extends GenericModel{
  private serverModel = new ServerModel;
  /* ************************************************
  //Alta de los datos del dominio
  ************************************************ */
  createDomain( _domain : any, servidor: string){
    var uid;
    var server_name;

    if(!_domain.clave){
      uid = firebase.database().ref("domains").push().key;
    }else{
      uid = _domain.clave;
    }

    if(!_domain.servidor_nombre){
      server_name = servidor;
    }else{
      server_name = _domain.servidor_nombre;
    }

    var domain:Domain = {
      clave:uid,
      nombre: _domain.nombre,
      url: _domain.url,
      tipo: _domain.tipo,
      usuario: _domain.usuario,
      password: _domain.password,
      contactoNombre : _domain.contacto_nombre,
      servidorNombre:server_name,
      phpVersion: _domain.phpVersion,
      tema: _domain.tema,
      wpVersion: _domain.wpVersion,
      plugins: _domain.plugins,
      observaciones: _domain.observaciones
    };

    //insertar objecto en un nodo
     firebase.database().ref(`domains/${uid}`).set(domain).then( snapshot => {
    });
  }
  /* ************************************************
  //Borrar los datos del dominio
  ************************************************ */
  deleteDomain(id: string, servidor: string){
    firebase.database().ref(`domains/${id}`).remove();
    this.serverModel.deleteDomain(servidor);
  }


  /* ************************************************
  //Obtener los datos del dominio
  ************************************************ */
  getDomain(servidor: string, promiss : Observable<Array<Domain>>){
    promiss = new Observable<Array<Domain>>(observable => {
      var functionReturnValues = () => {
      firebase.database().ref("domains").orderByChild("servidorNombre").equalTo(servidor).once("value").then( snapshot => {
            if( snapshot.val() != null){
              var array = [];
                snapshot.forEach( child_snapshot => {
                    //console.log( child_snapshot.val())
                    var model = child_snapshot.val() as Domain;
                    array.push( model );
                });
                observable.next(array);
            }
        });
      }
      functionReturnValues();
      firebase.database().ref(`domains`).on('child_added', functionReturnValues);
      firebase.database().ref(`domains`).on('child_changed', functionReturnValues);
      firebase.database().ref(`domains`).on('child_removed', functionReturnValues);
    });

    return promiss;
  }
/*
// Obtiene dominio completo sin filtro y en completo
*/

getDomains(){

  return new Observable<Array<Domain>>(observable => {
    var functionReturnValues = () => {
    firebase.database().ref("domains").once("value").then( snapshot => {
          if( snapshot.val() != null){
            var array = [];
              snapshot.forEach( child_snapshot => {
                  //console.log( child_snapshot.val())
                  var model = child_snapshot.val() as Domain;
                  array.push( model );
              });
              observable.next(array);
          }
      });
    }
    functionReturnValues();
    firebase.database().ref(`domains`).on('child_added', functionReturnValues);
    firebase.database().ref(`domains`).on('child_changed', functionReturnValues);
    firebase.database().ref(`domains`).on('child_removed', functionReturnValues);
  });
}

// Para limitar el número de consulta
getDomainsWithValue(max:number){

  return new Observable<Array<Domain>>(observable => {
    var functionReturnValues = () => {
    firebase.database().ref("domains").orderByChild("fechaVencimiento").limitToFirst(max).once("value").then( snapshot => {
          if( snapshot.val() != null){
            var array = [];
              snapshot.forEach( child_snapshot => {
                  //console.log( child_snapshot.val())
                  var model = child_snapshot.val() as Domain;
                  array.push( model );
              });
              observable.next(array);
          }
      });
    }
    functionReturnValues();
    firebase.database().ref(`domains`).on('child_added', functionReturnValues);
    firebase.database().ref(`domains`).on('child_changed', functionReturnValues);
    firebase.database().ref(`domains`).on('child_removed', functionReturnValues);
  });
}
}

export interface Domain{
  nombre:string;
  url:string;
  tipo?: string;
  usuario?:string;
  password?:string;
  clave?:string;
  servidorNombre?:string;
  contactoNombre?:string;
  phpVersion?: string;
  tema?: string;
  wpVersion?: string;
  plugins?: string;
  observaciones?: string;
}
